import { render } from "./RegisterInvoicePaymentModal.vue?vue&type=template&id=fe97e4d4&ts=true"
import script from "./RegisterInvoicePaymentModal.vue?vue&type=script&lang=ts"
export * from "./RegisterInvoicePaymentModal.vue?vue&type=script&lang=ts"

import "./RegisterInvoicePaymentModal.vue?vue&type=style&index=0&id=fe97e4d4&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__